import { Dialog } from "@fluentui/react-northstar";
import styled from "styled-components/macro";
import { DEVICE } from "../../../../constants/responsive";

export const DialogStyle = styled(Dialog)`
    /* max-width: 350px; */
    @media ${DEVICE.mobileS} {
        width: 90%;
        .ui-dialog__footer {
            grid-column: 1 / 4;
        }
        .ui-buttons > div {
            flex-direction: column-reverse;
            gap: 8px;
        }
    }
    @media ${DEVICE.mobileM} {
        max-width: 350px;
        .ui-dialog__footer {
            grid-column: 1 / 4;
        }
        .ui-buttons > div {
            flex-direction: row;
            gap: 8px;
        }
    }
`;
